import uuid from 'react-uuid';
import { GridColumn } from 'src/components/GridWrapper';
import AppendSequenceCell from 'src/sections/invoice_details/bulkAdd/AppendSequenceCell';
import AppendSequenceHeaderCell from 'src/sections/invoice_details/bulkAdd/AppendSequenceHeaderCell';
import BulkAddFieldCell from 'src/sections/invoice_details/bulkAdd/BulkAddFieldCell';
import BulkAddValueCell from 'src/sections/invoice_details/bulkAdd/BulkAddValueCell';
import ErrorCell from 'src/sections/invoice_details/bulkAdd/ErrorCell';
import { BulkLineItem } from 'src/sections/invoice_details/BulkAddLineItems';

export const BulkEditLineItemColumns: GridColumn<any>[] = [
  {
    field: 'selected',
    title: '',
    className: '!bg-transparent',
    width: 40,
    menu: false,
  },
  {
    field: 'errors',
    title: '',
    component: ErrorCell,
    width: 45,
    menu: false,
  },
  {
    field: 'field',
    title: 'Field',
    component: BulkAddFieldCell,
    width: 200,
    menu: false,
  },
  {
    field: 'value',
    title: 'Value',
    component: BulkAddValueCell,
    width: 314,
    menu: false,
  },
  {
    field: 'appendLineItem',
    title: 'Append Line Item Sequence Number',
    headerCell: AppendSequenceHeaderCell,
    component: AppendSequenceCell,
    width: 167,
    menu: false,
  },
];

export const initialBulkEditLineItemData: BulkLineItem[] = [
  {
    rowId: uuid(),
    index: 0,
    selected: false,
    field: 'productItemNum',
    title: 'Item #',
    value: 'Item',
    appendLineItem: true,
    showPreview: false,
  },
  {
    rowId: uuid(),
    index: 1,
    selected: false,
    field: 'description',
    title: 'Description',
    value: 'Item',
    appendLineItem: true,
    showPreview: false,
  },
  {
    rowId: uuid(),
    index: 2,
    selected: false,
    field: 'isTaxable',
    title: 'Taxable',
    value: true,
    appendLineItem: false,
    showPreview: false,
  },
  {
    rowId: uuid(),
    index: 3,
    selected: false,
    field: 'quantityReceived',
    title: 'Current Doc Qty',
    value: 1,
    appendLineItem: false,
    showPreview: false,
  },
  {
    rowId: uuid(),
    index: 4,
    selected: false,
    field: 'glCd',
    title: 'GL Code',
    value: '',
    appendLineItem: false,
    showPreview: false,
  },
  {
    rowId: uuid(),
    index: 5,
    selected: false,
    field: 'uom',
    title: 'UOM',
    value: 'EA',
    appendLineItem: false,
    showPreview: false,
  },
  {
    rowId: uuid(),
    index: 6,
    selected: false,
    field: 'priceAmt',
    title: 'Price',
    value: 0,
    appendLineItem: false,
    showPreview: false,
  },
];
